// File: custom-renderer.js
// Import Highway
import Highway from './highway';
import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import removeComponents from 'gia/removeComponents';
import _each from 'lodash.foreach'


import Menu from './menu'
import Slider from './slider'
import Studio from './studio'
import Clients from './clients'
import Services from './services'
import Projects from './projects'
import Capsule from './capsule'
import Contact from './contact'
import Sound from './sound'


import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class ProjectRenderer extends Highway.Renderer {
  // Hooks/methods
  // constructor(){
  //   super()


  // }

  onEnter() {
     
      $('body').addClass('novolume')
      
   
  }
  onLeave() {

    this.removeClassByPrefix(document.body, 'menu-color-')
    this.removeClassByPrefix(document.body, 'volume-')

    
    _each(document.querySelectorAll(".pitem"), (item)=>{
     
        item.vanillaTilt.destroy()
    })

   $('body').addClass('vm-loading')
    

  }
  onEnterCompleted() {
    const components = {

     // Animation: Animation,
    //   Slider: Slider,
    //   Studio: Studio,
    //   Clients: Clients,
    //   Services: Services,
      Menu: Menu,
    //   Projects: Projects,
      Contact: Contact,
      Sound: Sound
    }

   // console.log(VanillaTilt);

    // VanillaTilt.init(document.querySelectorAll(".pitem"), {
    //   reverse: true,
    //   max: 12
    // });

    loadComponents(components)

    

    $('body').removeClass('vm-loading novolume').addClass('loaded novolume')

  }
  onLeaveCompleted() {
      
    
      removeComponents()
      
  }

  removeClassByPrefix(node, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }
}

// Don`t forget to export your renderer
export default ProjectRenderer;
